import React, {Component} from 'react';
import {Link} from 'react-router';

class DAZNEmail extends Component {
    constructor(props) {
        super(props);

        let storageState = {};
        if(localStorage.nonWinner && localStorage.nonWinner !== 'undefined') {
            storageState.nonWinner = localStorage.nonWinner;
        }
        if(localStorage.daznEmail && localStorage.daznEmail !== 'undefined') {
            storageState.emailCopy = localStorage.daznEmail;
        }

        this.state = {
            nonWinner: false,
            emailCopy: null,
            ...storageState
        };
        this.validateEmail = this.validateEmail.bind(this);
    }

    validateEmail(e) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(e).toLowerCase());
    }

    render() {
        const emailCopy = this.state.emailCopy;

        let continueButton;
        if(this.validateEmail(this.state.email)) {
            continueButton = (
                <Link className="continueButton"
                    to={{pathname: '/dazn2'}}
                    onClick={() => {
                        if (this.validateEmail(this.state.email)) {
                            localStorage.setItem('email', this.state.email);
                            this.props.router.push('/dazn2');
                        }
                    }}>
                    Continue
                </Link>
            );
        } else {
            continueButton = (
                <Link className="continueButton">
                    Continue
                </Link>
            );
        }

        return (
            <div className="genericAppInner">
                <div className="page daznBackground">
                    <div className="verticalWrap contentWrap">
                        <div className="daznInnerWrap">
                            <div className="emailLogo">
                                <img src={"https://s3-us-west-2.amazonaws.com/contest.fanup.io/dazn.png"} alt="" />
                            </div>
                            <div className="emailUnderline" />
                            <form
                                onSubmit={e => {
                                    e.preventDefault();
                                    if (this.validateEmail(this.state.email)) {
                                        localStorage.setItem('email', this.state.email);
                                        this.props.router.push('/dazn2');
                                    }
                                }}>
                                <div className="emailCapture">
                                    <input className="emailCaptureInput"
                                        placeholder="Enter email"
                                        onChange={e => {
                                            this.setState({email: e.target.value});
                                        }}
                                        type="text"
                                    />
                                </div>
                            </form>
                            <h1 className="emailCopy">{emailCopy !== undefined && emailCopy !== null && emailCopy !== "null" ? emailCopy : ' '}</h1>
                            <div className="continue">
                                {continueButton}
                            </div>
                            <h3 className="disclaimer">By entering your email you agree to the <a href="http://fanupsms.com/">Terms and Conditions</a> and that you are 18 or older</h3>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DAZNEmail;



// WEBPACK FOOTER //
// ./src/components/DAZNEmail.js